<div class="flex flex-col gap-6">
  <span class="text-[18px] font-bold">Gestion del riesgo</span>

  <div class="flex flex-col gap-6">
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('systemClassification')"
        (change)="reviewFields.toggleField('systemClassification')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Nivel de riesgo</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('systemClassification')"
            class="-mt-2"
            [description]="previousReviewText('systemClassification')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">
          {{ riskLevelLabel(riskData?.systemClassification) || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('biases')"
        (change)="reviewFields.toggleField('biases')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Sesgos identificados</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('biases')"
            class="-mt-2"
            [description]="previousReviewText('biases')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">
          {{ riskData?.biases || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('risks')"
        (change)="reviewFields.toggleField('risks')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Riesgos identificados</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('risks')"
            class="-mt-2"
            [description]="previousReviewText('risks')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">
          {{ riskData?.risks || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
